import TableFooter from './component'

export default TableFooter
